import { Dispatch, FC, SetStateAction, Suspense, useEffect, useMemo, useRef, useState } from 'react';
import './CommonChatBox.scss';
import images from '../../../assets/images';
import ChatCard from './ChatCard';
import { CircularProgress, Tooltip } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { chatdataType, chatListType, defaultUserType, searchUserType, singleChatType, typingUserType } from '../CommonChats';
import { useAppSelector } from '../../../redux/app/hooks';
import { UPDATE_LAST_MESSAGE, UPDATE_CHAT_READ_MARKER } from '../api/ChatsQuery';
import { CHIME_TYPING_THROTTLE_MS, CLASSROOM_S3_PATH, FETCH_POLICY, FETCH_POLICY_NO_CACHE, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR } from '../../../utils/constants';
import ToasterWithMessage from '../../../components/toaster';
import { useNavigate } from 'react-router-dom';
import { useLazyQuery, useMutation } from '@apollo/client';
import dayjs from 'dayjs';
import { useReactMediaRecorder } from 'react-media-recorder-2';
import { GET_PRESIGNED_URL } from '../../../components/Popups/api/FileUploadQuery';
import moment from 'moment';
import axios from 'axios';
import ChatAttachmentPopup from '../../../components/Popups/ChatAttachmentPopup/ChatAttachmentPopup';
import ConfirmationPopup from '../../../components/ConfirmationPopup/ConfirmationPopup';
import React from 'react';
import { getScreenDimensions, getUserAvatarUrl } from '../../../utils/helper';
import { useChimeMessaging } from '../../../hooks/useChimeMessaging';
import { GET_USER_BY_CHIME_ARN } from '../../../Chime/helpers/ChatApi/ChatQuery';

// Use React.lazy to dynamically import the emoji picker to avoid HMR issues
const Picker = React.lazy(() => import('@emoji-mart/react'));

interface propsType {
  selectedChat: defaultUserType | undefined,
  selectedGroupChat: chatListType | undefined,
  selectedSearchChat: searchUserType | undefined,
  loadMore: () => void,
  hasMore: boolean,
  socketRef: any,
  chatMessages: chatdataType | undefined,
  setType: any,
  type: string,
  chatLoading: boolean,
  typingUsers: typingUserType[],
  setViewType: Dispatch<SetStateAction<string>>,
  setViewUrl: Dispatch<SetStateAction<string>>,
  setIsSidebarOpen: (val: boolean) => void;
  isSidebarOpen: boolean;
  isChime: boolean;
  chimeChannelArn: string | null;
  getChatList:any
  handleChimeTyping: (content: any) => void;
}

export interface EditFileType {
  s3Path: string;
  fileType: string;
}

const CommonChatBox: FC<propsType> = ({ selectedChat, selectedGroupChat, selectedSearchChat, loadMore, hasMore, socketRef, chatMessages, setType, type, chatLoading, typingUsers, setViewType, setViewUrl, isSidebarOpen, setIsSidebarOpen, isChime, chimeChannelArn, handleChimeTyping,getChatList }) => {
  const [message, setMessage] = useState('');
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const lastChimeTypingTimeRef = useRef<number>(0);
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const { voiceChatIcon, sendIcon, AttachmentIcon, UserActiveIcon, StopIcon, DeleteGif, whiteClose, pdfImg, SendDisableIcon, excelPreview, docsImg, powerpoint, epub, ChatEmoji, emoji2, closeIcon, csvImg, exitIcon } = images;
  const { error } = ToasterWithMessage();
  const role = useAppSelector((state) => state.auth.role);
  const navigate = useNavigate();
  const [audioRecording, setAudioRecording] = useState(false);
  const [isPause, setIsPause] = useState(false);
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  // const [audioBlobUrls, setAudioBlobUrls] = useState<string[]>([]);
  const contentEditableRef = useRef<HTMLDivElement | null>(null);
  const bucketname = process.env.REACT_APP_MEDIA_BUCKET_NAME;
  const region = process.env.REACT_APP_REGION;
  const [open,setOpen] = useState<boolean>(false);
  const [uploadFileData, setUploadFileData] = useState<File|null>(null);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [selectedFile,setSelectedFile] = useState<File|null>(null);
  const [uploadLoading,setUploadLoading] = useState<boolean>(false);
  const [attachmentUrl,setAttachmentUrl] = useState<string>('');
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const [currentAudio, setCurrentAudio] = useState<HTMLAudioElement | null>(null);
  const [replyToMessage, setReplyToMessage] = useState<singleChatType | null>(null);
  const [highlightedMessageId,setHighlightedMessageId] = useState<string|null>(null);
  const shouldUploadRef = useRef(true);   // Use a ref for shouldUpload
  const timeoutRef = useRef<NodeJS.Timeout | null>(null); // Ref to store the timeout ID
  const messageRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [editMessage, setEditMessage] = useState<singleChatType | null>(null);
  const [editFile, setEditFile] = useState<EditFileType | null>(null);
  const [isMessageEdited, setIsMessageEdited] = useState(false);
  const [isFileEdited, setIsFileEdited] = useState(false);
  const { isMobileScreen } = getScreenDimensions();
  const [chimeChannelArnState, setChimeChannelArnState] = useState<string>('');
  const chimeChannelArnRef = useRef<string>(''); // Ref to track current channel for realtime filtering
  const [chimeNextToken, setChimeNextToken] = useState<string | undefined>(undefined);
  const [chimeMessages, setChimeMessages] = useState<any[]>([]);
  const [chimeMessagesLoading, setChimeMessagesLoading] = useState<boolean>(false); // Track when messages are being fetched
  const [sendingMessage, setSendingMessage] = useState<boolean>(false); // Track when a message is being sent
  const { sendMessage: sendChimeMessage, updateMessage: updateChimeMessage, listMessages, connectRealtime, disconnectRealtime, isConnected, loading: chimeClientLoading, sendSignal,updateChannelReadMarker } = useChimeMessaging({userArn: profile.getCurrentUser?.nodes?.[0]?.chimeUserArn || '', channelArn: chimeChannelArnState});
  const getChatListTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const readMarkerTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [updateChatReadMarkerMutation] = useMutation(UPDATE_CHAT_READ_MARKER, {
    onError: (err) => {
      console.warn("Failed to update chat read marker:", err?.message);
    },
  });

  const [getUserByChimeArn] = useLazyQuery(GET_USER_BY_CHIME_ARN, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onError: (err) => {
      error(err?.message);
    },
  });

  const debouncedGetChatList = (variables: any) => {
    if (getChatListTimeoutRef.current) {
      clearTimeout(getChatListTimeoutRef.current);
    }

    getChatListTimeoutRef.current = setTimeout(() => {
      getChatList({ variables });
    }, 400);
  };

  const debouncedUpdateReadMarker = (channelArn: string) => {
    if (readMarkerTimeoutRef.current) {
      clearTimeout(readMarkerTimeoutRef.current);
    }

    readMarkerTimeoutRef.current = setTimeout(() => {
      updateChatReadMarkerMutation({
        variables: { channelArn },
      });
    }, 500);
  };

  useEffect(() => {
    console.log("[Debug] profile.getCurrentUser?.nodes?.[0]?.chimeUserArn", profile.getCurrentUser?.nodes?.[0]?.chimeUserArn);
  }, [profile.getCurrentUser?.nodes?.[0]?.chimeUserArn]);

  // Keep the ref in sync with the state for use in realtime callback
  useEffect(() => {
    chimeChannelArnRef.current = chimeChannelArnState;
    console.log("[Debug] Updated chimeChannelArnRef to:", chimeChannelArnState);
  }, [chimeChannelArnState]);

  // Handle Chime channel creation and connection when chat is selected
  useEffect(() => {
    console.log("[Debug] Chat selection changed, isChime:", isChime, "chimeChannelArn prop:", chimeChannelArn);
    
    // Reset Chime messages when chat selection changes
    if (isChime) {
      setChimeMessages([]);
      setChimeNextToken(undefined);
      setChimeMessagesLoading(true); // Start loading state when switching chats
    }
    
    if (isChime && (selectedChat || selectedGroupChat)) {
      const initChimeChat = async () => {
        try {
          // Use the chimeChannelArn from props (works for both group chats and individual chats)
          if (chimeChannelArn) {
            console.log("[Debug] Using chimeChannelArn from props:", chimeChannelArn);
            setChimeChannelArnState(chimeChannelArn);
          } else {
            console.warn("[Debug] No chimeChannelArn available for this chat");
            setChimeChannelArnState('');
          }
        } catch (error) {
          console.error("Failed to initialize Chime chat:", error);
        }
      };
      
      initChimeChat();
    } else if (!isChime) {
      // Reset Chime states when switching to WebSocket
      setChimeChannelArnState('');
      setChimeMessages([]);
      setChimeNextToken(undefined);
    }
    
    // Note: We don't disconnect realtime on channel change since the connection is per-user, not per-channel
    // Messages are filtered by channelArn in the realtime callback
  }, [selectedChat?.chimeChannelArn, selectedGroupChat?.chimeChannelArn, isChime, chimeChannelArn]);

  // Cleanup: disconnect realtime only when component unmounts
  useEffect(() => {
    return () => {
      if (isChime) {
        console.log("[Debug] Cleaning up Chime connection on component unmount");
        disconnectRealtime();
      }
    };
  }, [isChime, disconnectRealtime]);

  // Load initial messages when channel is ready
  useEffect(() => {
    const userArn = profile.getCurrentUser?.nodes?.[0]?.chimeUserArn;
    console.log("[Debug] Channel ARN state changed:", chimeChannelArnState, "userArn:", userArn, "chimeClientLoading:", chimeClientLoading);
    if (isChime && chimeChannelArnState && userArn && !chimeClientLoading) {
      console.log("[Debug] Loading initial Chime messages");
      const timer = setTimeout(() => {
        loadChimeMessages();
      }, 50);
      return () => clearTimeout(timer);
    } else if (isChime && !userArn) {
      console.warn("[Debug] Cannot load Chime messages - userArn is missing", { userArn });
    } else if (isChime && chimeClientLoading) {
      console.log("[Debug] Waiting for Chime client to finish loading before fetching messages");
    }
  }, [chimeChannelArnState, isChime, chimeClientLoading, profile.getCurrentUser?.nodes?.[0]?.chimeUserArn]);

  // Connect to Chime realtime when channel is ready
  useEffect(() => {
    const userArn = profile.getCurrentUser?.nodes?.[0]?.chimeUserArn;
    console.log("[Debug] Realtime connection effect - isChime:", isChime, "chimeChannelArnState:", chimeChannelArnState, "userArn:", userArn, "isConnected:", isConnected, "chimeClientLoading:", chimeClientLoading);
    if (isChime && chimeChannelArnState && userArn && !chimeClientLoading) {
      if (!isConnected) {
        console.log("[Debug] Attempting to connect to realtime...");
        connectRealtime((message: any) => {
          console.log("[Debug] Received realtime message:", JSON.stringify(message));
          
          // Filter: Only process messages for the current channel (use ref for latest value)
          const messageChannelArn = message?.channelArn;
          const currentChannelArn = chimeChannelArnRef.current;
          if (messageChannelArn && messageChannelArn !== currentChannelArn) {
            console.log("[Debug] Message is for a different channel, ignoring. Message channel:", messageChannelArn, "Current channel:", currentChannelArn);
            debouncedGetChatList({
              input: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                messagingProvider: isChime ? "CHIME" : "WEBSOCKET",
                limit: null,
                offset: null,
              },
            });
            return;
          }

          // Handle ephemeral events (typing, presence, etc.)
          if (message?.content?.event) {
            if (message.senderArn === userArn) return;

            switch (message.content.event) {
              case "typing":
                getUserByChimeArn({
                  variables: { chimeUserArn: message.senderArn },
                }).then(({ data }) => {
                  handleChimeTyping({
                    channelArn: message.channelArn,
                    userArn: message.senderArn,
                    userName: data?.allUsers?.nodes?.[0].uFullName ?? "Unknown User",
                  });
                });
                return;

              default:
                return;
            }
          }
          
          // Normalize realtime message shape and ensure it has an id/createdAt
          const normalized = message?.content ? { ...message.content } : { ...(message || {}) };
          // Parse createdAt: handle both ISO strings and numeric timestamps
          let parsedCreatedAt = Date.now();
          if (normalized?.createdAt) {
            const parsed = typeof normalized.createdAt === 'string' 
              ? new Date(normalized.createdAt).getTime() 
              : Number(normalized.createdAt);
            if (!isNaN(parsed)) {
              parsedCreatedAt = parsed;
            }
          }
          // IMPORTANT: Use the actual Chime MessageId (message?.messageId) for the id field
          // This is required for edit/update operations. The client-generated id in content is only a fallback.
          const chimeMessageId = message?.messageId || normalized?.id || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          const withId = {
            id: chimeMessageId,
            createdAt: parsedCreatedAt,
            ...normalized,
          };
          console.log("[Debug] Using Chime MessageId:", chimeMessageId, "Content id:", normalized?.id, "Message type:", message?.type);
          console.log("[Debug] Normalized realtime message - ID:", withId.id, "Message:", withId.message);
          
          // Handle different message types from Chime
          const messageType = message?.type;
          
          if (messageType === 'UPDATE_CHANNEL_MESSAGE') {
            // This is an edited message - update existing message in the list
            console.log("[Debug] UPDATE_CHANNEL_MESSAGE received, updating existing message:", withId.id);
            setChimeMessages(prev => {
              const existingIndex = prev.findIndex(m => m?.id === withId.id);
              if (existingIndex !== -1) {
                console.log("[Debug] Found existing message at index:", existingIndex, "Updating...");
                const updated = [...prev];
                updated[existingIndex] = { ...updated[existingIndex], ...withId };
                return updated;
              } else {
                console.log("[Debug] Message not found for update, adding as new");
                return [withId, ...prev];
              }
            });
          } else {
            // This is a new message (CREATE_CHANNEL_MESSAGE or other types)
            // Check if message already exists before adding (prevent duplicates)
            setChimeMessages(prev => {
              console.log("[Debug] Current chimeMessages count:", prev.length, "Checking for ID:", withId.id);
              console.log("[Debug] Existing message IDs:", prev.map(m => m?.id));
              const exists = prev.some(m => m?.id && m.id === withId.id);
              if (exists) {
                console.log("[Debug] DUPLICATE DETECTED - Message already exists:", withId.id);
                return prev;
              }
              console.log("[Debug] New message added:", withId.id);
              return [withId, ...prev];
            });

            console.log("[Marker] Marker called from receive message.", new Date().toISOString(), currentChannelArn);
            // debouncedUpdateReadMarker(currentChannelArn);
            try{
              updateChannelReadMarker(currentChannelArn);
            }catch(err){
              console.error("Failed to update channel read marker:", err);
            }
            
          }
          
          if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView(false);
          }
        });
      } else {
        console.log("[Debug] Already connected to realtime");
      }
    } else if (isChime && !userArn) {
      console.warn("[Debug] Cannot connect to realtime - userArn is missing");
    } else if (isChime && chimeClientLoading) {
      console.log("[Debug] Waiting for Chime client to finish loading before realtime connect");
    }
  }, [chimeChannelArnState, isChime, isConnected, connectRealtime, chimeClientLoading, profile.getCurrentUser?.nodes?.[0]?.chimeUserArn]);

  useEffect(() => {
    return () => {
      if (getChatListTimeoutRef.current) {
        clearTimeout(getChatListTimeoutRef.current);
      }
      if (readMarkerTimeoutRef.current) {
        clearTimeout(readMarkerTimeoutRef.current);
      }
    };
  }, []);

  // Load Chime messages with pagination
  const loadChimeMessages = async () => {
    const userArn = profile.getCurrentUser?.nodes?.[0]?.chimeUserArn;
    // Capture the channel ARN at the start to detect if it changes during async operation
    const requestChannelArn = chimeChannelArnState;
    
    if (!isChime || !requestChannelArn) {
      console.log("[Debug] Skipping loadChimeMessages - isChime:", isChime, "chimeChannelArnState:", requestChannelArn);
      return;
    }

    if (!userArn) {
      console.warn("[Debug] Skipping loadChimeMessages - userArn is empty");
      return;
    }

    if (chimeClientLoading) {
      console.log("[Debug] Chime client still loading; deferring loadChimeMessages");
      setTimeout(loadChimeMessages, 50);
      return;
    }
    
    console.log("[Debug] loadChimeMessages starting - userArn:", userArn, "channelArn:", requestChannelArn, "nextToken:", chimeNextToken);
    // Only set loading true for initial load (no nextToken yet)
    if (!chimeNextToken) {
      setChimeMessagesLoading(true);
    }
    try {
      const result = await listMessages({
        ...(chimeNextToken ? { nextToken: chimeNextToken } : {}),
        pageSize: 30
      });
      
      // Check if channel changed during async operation - ignore stale response
      if (requestChannelArn !== chimeChannelArnRef.current) {
        console.log("[Debug] Channel changed during message load, ignoring stale response. Requested:", requestChannelArn, "Current:", chimeChannelArnRef.current);
        return;
      }
      
      const { messages, nextToken } = result;
      console.log("[Debug] Loaded messages from history:", messages.length, "nextToken:", nextToken);
      // Normalize history messages to UI shape (merge id into content)
      // IMPORTANT: m.id from listMessages is already the Chime MessageId - we must preserve it
      const normalized = (messages || []).map((m: any) => {
        // Parse createdAt: handle both ISO strings and numeric timestamps
        let parsedCreatedAt = Date.now();
        if (m?.createdAt) {
          const parsed = typeof m.createdAt === 'string' 
            ? new Date(m.createdAt).getTime() 
            : Number(m.createdAt);
          if (!isNaN(parsed)) {
            parsedCreatedAt = parsed;
          }
        }
        // First spread content, then override with Chime MessageId to ensure it's not overwritten      
        const chimeMessageId = m?.content?.id || m?.id || m?.MessageId || m?.messageId || `${m?.createdAt || Date.now()}-${Math.random().toString(36).slice(2)}`;
        return {
          ...(m?.content || {}),
          id: chimeMessageId, // Override any client-generated id from content with actual Chime MessageId
          createdAt: parsedCreatedAt,
        };
      });
      console.log("[Debug] Normalized history messages - using Chime MessageIds:", normalized.map((m: any) => ({ id: m.id, contentId: m?.content?.id })));
      // Merge with existing messages, avoiding duplicates
      setChimeMessages(prev => {
        console.log("[Debug] Before merge - Current message count:", prev.length);
        console.log("[Debug] Current message IDs:", prev.map(m => m?.id));
        const existingIds = new Set(prev.map(m => m?.id).filter(Boolean));
        const newMessages = normalized.filter(m => !existingIds.has(m.id));
        console.log("[Debug] New unique messages to add:", newMessages.length, "IDs:", newMessages.map((m: any) => m.id));
        const merged = [...prev, ...newMessages];
        console.log("[Debug] After merge - Total message count:", merged.length);
        return merged;
      });

      console.log("[Marker] Marker called from load messages.", new Date().toISOString(), chimeChannelArnRef.current);
      // await updateChatReadMarkerMutation({
      //   variables: {
      //     channelArn: chimeChannelArnRef.current,
      //   },
      // });

      try{
        await updateChannelReadMarker(chimeChannelArnRef.current);
      }catch(err){
        console.error("Failed to update channel read marker:", err);
      }
      await getChatList({
        variables: {
          input: {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
            messagingProvider: isChime ? "CHIME" : "WEBSOCKET",
            limit: null,
            offset: null,
          },
        },
      });

      setChimeNextToken(nextToken);
      setChimeMessagesLoading(false); // Done loading
    } catch (error: any) {
      console.error("Failed to load Chime messages:", error?.message || error);
      setChimeMessagesLoading(false); // Done loading even on error
    }
  };

  const handleEditMessage = (data: singleChatType) => {
    // Reset input states
    resetEditMessage();

    const chat = data ?? {};
    console.log("[Log] Currently editing chat", chat);
    const chatType = chat.msgType;
    const [attachment] = chat.combinedMessage ?? [];
    const attachmentType = attachment?.type;
    const attachmentFileType = chat?.combinedMessage?.[0].type || chatType;

    setEditMessage(chat);
    if (chatType === "text" || chatType === "combinedMessage") {
      setMessage(chat.message);
    }

    if (chatType !== "text" && chatType !== "mp3" && chatType !== "3gp" && chatType !== "webm" && chatType !== "audio" && attachmentType !== "mp3" && attachmentType !== "3gp" && attachmentType !== "webm" && attachmentType !== "audio") {
      if (chatType === "combinedMessage") {
        setEditFile({ s3Path: attachment.content, fileType: attachmentFileType });
      } else {
        setEditFile({ s3Path: chat.message, fileType: attachmentFileType });
      }
    }

    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  const handleDeleteChimeMessage = async (messageId: string, isDeleteForMe: boolean) => {
    const messageToDelete = chimeMessages.find((m) => m.id === messageId);
    if (!messageToDelete) {
      throw new Error("Message not found");
    }

    let updatedContent: any = {
      ...messageToDelete,
    };

    if (isDeleteForMe) {
      updatedContent.deletedForMe = Date.now().toString();
    } else {
      updatedContent.deletedForEveryOne = Date.now().toString();
    }

    await updateChimeMessage(messageId, updatedContent);

    setChimeMessages((prev) => prev.map((m) => (m.id === messageId ? updatedContent : m)));
  };

  // to get presignedURL
  const [getPreSignedUrl] = useLazyQuery(GET_PRESIGNED_URL, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => { },
    onError: (err) => {
      // error("Something went wrong!")
    }
  });
      
  const { startRecording, stopRecording, resumeRecording, pauseRecording, clearBlobUrl } = useReactMediaRecorder({
    audio: true,
    onStop(blobUrl, blob) {
      if (shouldUploadRef.current && blob) {
        console.log('Uploading blob...');
        uploadToS3(blob, 'Audio');
      }
      // setAudioBlobUrls((prevUrls:string[]) => [...prevUrls, blobUrl]); // Append new audio URL
      clearBlobUrl();
    },
  });
  console.log('uploadfiledata--->',uploadFileData)
  const uploadToS3 = async (blob: Blob, type: 'Audio' | 'Video') => {
    const newFileName = `${CLASSROOM_S3_PATH}materials/${type.toLowerCase()}/${moment().unix()}.webm`;
        await getPreSignedUrl({
          variables: {
            input: {
              key: newFileName
            }
          }
        }).then(async ({ data }) =>{
          const { preSignedUrl } = data.getUploadPresignedUrl;
          const response = await axios.put(preSignedUrl, blob, {
            headers: {
              "Content-Type": `${type.toLowerCase()}/*`,
            }
          });
          if(response?.status === 200){
            const fileUrl = preSignedUrl.split('?')[0];
            const url = fileUrl.split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
            console.log('url',url);
              console.log('chatmsg inside send msg 151',selectedChat,selectedSearchChat,selectedGroupChat)
              if (url.trim() !== '') {
                // Add your logic to send the message here
                if (isChime) {
                  setSendingMessage(true);
                  try {
                  // Send via Chime SDK - don't include 'id', Chime will assign MessageId
                  const chimeMessageContent = {
                    toUserId: selectedChat?.to?.uId,
                    toUserName: selectedChat?.to?.uFullName,
                    userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
                    userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
                    userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
                    chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
                    replyId: replyToMessage ? replyToMessage?.id : null,
                    replyData: replyToMessage ? {
                      id: replyToMessage?.id,
                      userId: replyToMessage?.userId,
                      userName: replyToMessage?.userName,
                      userAvatarUrl: replyToMessage?.userAvatarUrl,
                      message: replyToMessage?.message,
                      msgType: replyToMessage?.msgType,
                      combinedMessage: replyToMessage?.combinedMessage,
                      fileinfo: replyToMessage?.fileinfo,
                      createdAt: replyToMessage?.createdAt
                    } : null,
                    message: url,
                    combinedMessage: null,
                    msgType: "mp3",
                    createdAt: Date.now()
                  };
                  console.log("[Debug] Sending voice recording via Chime", chimeMessageContent);
                  await sendChimeMessage(chimeMessageContent);
                  updateLastMessage({
                    variables: {
                      chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
                      lastMessageSendAt: dayjs().utc()
                    }
                  });
                  } finally {
                    setSendingMessage(false);
                  }
                } else {
                  // Send via WebSocket
                  const messageData = {
                    "type": "sendMessage",
                    "data": {
                      "toUserId": selectedChat?.to?.uId,
                      "toUserName": selectedChat?.to?.uFullName,
                      "userId": profile?.getCurrentUser?.nodes?.[0]?.uId,
                      "userName": profile?.getCurrentUser?.nodes?.[0]?.uFullName,
                      "userAvatarUrl": getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
                      "chatRoomId": selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
                      "replyId":replyToMessage ? replyToMessage?.id : null,
                      "message": url,
                      "combinedMessage": null,
                      "msgType": "mp3"
                    }
                  };
                  console.log('message data 169', messageData)
                  if (socketRef.current) {
                    socketRef.current.send(JSON.stringify(messageData));
                    updateLastMessage({
                      variables: {
                        chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
                        lastMessageSendAt: dayjs().utc()
                      }
                    });
                  }
                }
                if (messagesEndRef.current) {
                  messagesEndRef.current.scrollIntoView(false);
                }
                setMessage(''); // Clear the input box after sending
                if (textareaRef.current) {
                  textareaRef.current.focus();
                  textareaRef.current.style.height = 'auto';
                }
                handleCloseReply();
              }
          }
        }).catch((error) => {
          error('Voice message upload failed');
      });
    clearBlobUrl();
}

const getFileType = (fileData: File) => {

  if (["image/jpeg", "image/png", "image/svg+xml", "image/jpg"].includes(fileData?.type)) {
    return "png";
  }
  else if (fileData?.type === "video/mp4") {
    return "mp4";
  }
  else if (fileData?.type === "application/pdf") {
    return "pdf";
  }
  else if(fileData?.type === "application/vnd.ms-excel"){
    return "xls";
  }
  else if(fileData?.type === "text/csv"){
    return "csv";
  }
  else if (fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    return "xlsx";
  }
  else if (fileData?.type === "application/msword"){
    return "doc";
  }
  else if (fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
    return "docx";
  } 
  else if(fileData?.type === "application/vnd.ms-powerpoint"){
    return "ppt";
  }
  else if (fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
    return "pptx";
  }
  else if (fileData?.type === "application/epub+zip") {
    return "epub";
  }
  else {
    return "text";
  }
};

const handleEditMessageWithAttachment = (messageType: string, s3Path: string, attachment: any, fileinfo: any) => {
  const { chatRoomId, id: messageId, message: oldMessage } = editMessage || {};

  if (!chatRoomId || !messageId) {
    return;
  }

  const editMessagePayload: Record<string, any> = {
    type: "editMessageById",
    data: { chatRoomId, messageId, combinedMessage: attachment, msgType: messageType, fileinfo },
  };

  if (message.trim()) {
    if (message.trim() !== oldMessage) {
      // Edited message and replaced/uploaded image
      editMessagePayload.data = { ...editMessagePayload.data, message };
      return editMessagePayload;
    } else {
      // Same message and replaced/uploaded image
      return editMessagePayload;
    }
  } else {
    // Removed/No message and replaced/uploaded image
    editMessagePayload.data = { ...editMessagePayload.data, combinedMessage: null, message: s3Path };
    return editMessagePayload;
  }
};

const uploadAttachmentToS3 = async (file: File|null) => {
  if(file !== null){
  setUploadLoading(true);
  // Extract the base name and extension from file.name
  const lastDotIndex = file?.name.lastIndexOf('.');
  const baseName = lastDotIndex !== -1 ? file?.name.slice(0, lastDotIndex) : '';
  const extension = lastDotIndex !== -1 ? file?.name.slice(lastDotIndex) : '';
  // Replace spaces with underscores in fileName
  const sanitizedFileName = baseName?.replace(/ /g, '_');
  // Construct the new file name
  const newFileName = `${CLASSROOM_S3_PATH}materials/${sanitizedFileName}-${moment().unix()}${extension}`;
      await getPreSignedUrl({
        variables: {
          input: {
            key: newFileName
          }
        }
      }).then(async ({ data }) =>{
        const { preSignedUrl } = data.getUploadPresignedUrl;
        const response = await axios.put(preSignedUrl, file, {
          headers: {
            "Content-Type": file?.type
          }
        });
        if(response?.status === 200){
          const fileUrl = preSignedUrl.split('?')[0];
          const dataurl = fileUrl.split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
          console.log('url for attachment',dataurl);
            console.log('chatmsg inside send msg 290',selectedChat,selectedSearchChat,selectedGroupChat)
            if (dataurl.trim() !== '') {
               setAttachmentUrl(dataurl);
               setUploadLoading(false);
              if ((dataurl !== null)) {
                const fileType = getFileType(file);
                const fileinfo = {
                  filename: file.name,
                  filesize: file.size,
                  filetype: file.type
                };
                
                if (isChime) {
                  // Check if this is an edit or a new message
                  setSendingMessage(true);
                  try {
                  if (editMessage) {
                    // Edit existing message with new attachment via Chime
                    const { id: existingMessageId } = editMessage;
                    
                    if (!existingMessageId) {
                      console.error("[Debug] Cannot edit message - no message ID");
                      setUploadLoading(false);
                      return;
                    }

                    let updatedContent: any = {
                      ...editMessage,
                      isMessageEdited: true,
                      fileinfo: fileinfo,
                    };

                    if (message.trim() !== '') {
                      // Combined message with attachment and text
                      updatedContent = {
                        ...updatedContent,
                        message: message,
                        combinedMessage: [{
                          type: fileType,
                          content: dataurl
                        }],
                        msgType: "combinedMessage",
                      };
                    } else {
                      // Only attachment (no text)
                      updatedContent = {
                        ...updatedContent,
                        message: dataurl,
                        combinedMessage: null,
                        msgType: fileType,
                      };
                    }

                    console.log("[Debug] Updating Chime message with new attachment:", existingMessageId, updatedContent);
                    await updateChimeMessage(existingMessageId, updatedContent);
                    console.log("[Debug] Chime message with attachment updated successfully");

                    // Update the local chimeMessages state to reflect the edit
                    setChimeMessages(prev => prev.map(m => 
                      m.id === existingMessageId ? { ...m, ...updatedContent } : m
                    ));
                  } else {
                    // Send new message via Chime SDK - don't include 'id', Chime will assign MessageId
                    let chimeMessageContent: any;
                    
                    if (message.trim() !== '') {
                      // Combined message with attachment and text
                      chimeMessageContent = {
                        toUserId: selectedChat?.to?.uId,
                        toUserName: selectedChat?.to?.uFullName,
                        userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
                        userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
                        userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
                        chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
                        replyId: replyToMessage ? replyToMessage?.id : null,
                        replyData: replyToMessage ? {
                          id: replyToMessage?.id,
                          userId: replyToMessage?.userId,
                          userName: replyToMessage?.userName,
                          userAvatarUrl: replyToMessage?.userAvatarUrl,
                          message: replyToMessage?.message,
                          msgType: replyToMessage?.msgType,
                          combinedMessage: replyToMessage?.combinedMessage,
                          fileinfo: replyToMessage?.fileinfo,
                          createdAt: replyToMessage?.createdAt
                        } : null,
                        message: message,
                        combinedMessage: [{
                          type: fileType,
                          content: dataurl
                        }],
                        msgType: "combinedMessage",
                        fileinfo: fileinfo,
                        createdAt: Date.now()
                      };
                    } else {
                      // Only attachment
                      chimeMessageContent = {
                        toUserId: selectedChat?.to?.uId,
                        toUserName: selectedChat?.to?.uFullName,
                        userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
                        userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
                        userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
                        chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
                        replyId: replyToMessage ? replyToMessage?.id : null,
                        replyData: replyToMessage ? {
                          id: replyToMessage?.id,
                          userId: replyToMessage?.userId,
                          userName: replyToMessage?.userName,
                          userAvatarUrl: replyToMessage?.userAvatarUrl,
                          message: replyToMessage?.message,
                          msgType: replyToMessage?.msgType,
                          combinedMessage: replyToMessage?.combinedMessage,
                          fileinfo: replyToMessage?.fileinfo,
                          createdAt: replyToMessage?.createdAt
                        } : null,
                        message: dataurl,
                        combinedMessage: null,
                        msgType: fileType,
                        fileinfo: fileinfo,
                        createdAt: Date.now()
                      };
                    }
                    console.log("[Debug] Sending attachment via Chime", chimeMessageContent);
                    await sendChimeMessage(chimeMessageContent);
                  }
                  } finally {
                    setSendingMessage(false);
                  }
                  updateLastMessage({
                    variables: {
                      chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
                      lastMessageSendAt: dayjs().utc()
                    }
                  });
                  
                  setMessage('');
                  setUploadFileData(null);
                  setUploadLoading(false);
                  setAttachmentUrl('');
                  handleCloseReply();
                  setEditMessage(null);
                  setEditFile(null);
                  setIsMessageEdited(false);
                  setIsFileEdited(false);
                  
                  if (messagesEndRef.current) {
                    messagesEndRef.current.scrollIntoView(false);
                  }
                } else {
                  // Send via WebSocket
                  const messageData = {
                    type: "sendMessage",
                    data: {
                      toUserId: selectedChat?.to?.uId,
                      toUserName: selectedChat?.to?.uFullName,
                      userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
                      userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
                      userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
                      chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
                      replyId:replyToMessage ? replyToMessage?.id : null,
                      message: (message && message.trim() !== "" && dataurl && uploadFileData)
                        ? message
                        : (dataurl && uploadFileData && (!message || message.trim() === ""))
                        ? dataurl
                        : message,
                      combinedMessage:(message && message.trim() !== "" && dataurl && uploadFileData)
                      ? [
                          {
                            content: dataurl,
                            type: getFileType(uploadFileData)
                          },
                        ]
                      : null,
                      fileinfo:(dataurl && uploadFileData)?
                        {
                          filename: uploadFileData?.name?.trim(),
                          filetype: uploadFileData?.type,
                          filesize: uploadFileData?.size
                        }:null,
                      msgType:
                        message && message.trim() !== "" && dataurl && uploadFileData
                          ? "combinedMessage"
                          : dataurl && uploadFileData && (!message || message.trim() === "")
                          ? getFileType(uploadFileData) : "text",
                    },
                  };
            
                  console.log('message data 333', messageData)
                  if (socketRef.current && socketRef?.current?.readyState === 1) {
                    const { msgType, message, combinedMessage, fileinfo } = messageData.data || {};
                    if (editMessage) {
                      const editPayload = handleEditMessageWithAttachment(msgType, message, combinedMessage, fileinfo);
                      console.log("[Log] Edit payload with attachment", editPayload);
                      if (!editPayload) {
                        return;
                      }
                      socketRef.current.send(JSON.stringify(editPayload));
                    } else {
                      socketRef.current.send(JSON.stringify(messageData));
                      updateLastMessage({
                        variables: {
                          chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
                          lastMessageSendAt: dayjs().utc()
                        }
                      });
                    }
                  }
                }
                if (messagesEndRef.current) {
                  messagesEndRef.current.scrollIntoView(false);
                }
                setMessage(''); // Clear the input box after sending
                setAttachmentUrl('');
                setUploadFileData(null);
                handleCloseReply();
                setEditMessage(null);
                setEditFile(null);
                setIsMessageEdited(false);
                setIsFileEdited(false);
                if (textareaRef.current) {
                  textareaRef.current.focus();
                  textareaRef.current.style.height = 'auto';
                }
              }

            }
        }
      }).catch((error) => {
        error('Attachment upload failed');
        setUploadLoading(false);
    });
    resetRecording();
  }
}

  const [updateLastMessage, { loading }] = useMutation(UPDATE_LAST_MESSAGE, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const handleInputChange = (e:any) => {
    const textarea = e.target;
    if(textarea){
    textarea.style.height = "auto"; // Reset the height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set the height dynamically based on content
    }
    if (e.target.value?.trim() !== editMessage?.message) {
      setIsMessageEdited(true);
    }
    setMessage(e.target.value);
    setAudioRecording(false);
    resetRecording();
    console.log('inside the input change')
    if (isChime) {
      const now = Date.now();
      if (now - lastChimeTypingTimeRef.current >= CHIME_TYPING_THROTTLE_MS) {
        sendSignal({
          event: "typing",
        });
        lastChimeTypingTimeRef.current = now;
      }
    } else if (socketRef?.current?.readyState === 1) {
      socketRef.current?.send(
        JSON.stringify({
          type: "typing",
          data: {
            chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
            fromUserId: profile?.getCurrentUser?.nodes?.[0]?.uId,
            fromUserName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
          },
        })
      );
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevents adding a newline character
      setShowPicker(false)
      sendMessage();
    }
  };

  const getEditTextMessagePayload = () => {
    const { chatRoomId, id: messageId, msgType: oldMessageType, message: oldMessage, combinedMessage: attachment } = editMessage || {};

    if (!chatRoomId || !messageId) {
      return;
    }
    if (oldMessageType !== "text" && oldMessageType !== "combinedMessage" && !message.trim() && !editFile) {
      return;
    }
    if (!editFile && !message.trim()) {
      return;
    }

    const editMessagePayload: Record<string, any> = {
      type: "editMessageById",
      data: { chatRoomId, messageId },
    };

    if (message.trim() !== oldMessage) {
      if (oldMessageType === "combinedMessage") {
        if (isFileEdited) {
          // Edited message and removed image
          editMessagePayload.data = { ...editMessagePayload.data, message, combinedMessage: null, msgType: "text" };
          return editMessagePayload;
        } else if (!message.trim()) {
          // Removed message with same image
          editMessagePayload.data = { ...editMessagePayload.data, message: attachment?.[0].content, combinedMessage: null, msgType: attachment?.[0].type };
          return editMessagePayload;
        } else if (!isFileEdited) {
          // Edited message with the same image
          editMessagePayload.data = { ...editMessagePayload.data, message, msgType: "combinedMessage" };
          return editMessagePayload;
        }
      } else if (oldMessageType === "text") {
        // Edited text message
        editMessagePayload.data = { ...editMessagePayload.data, message, msgType: "text" };
        return editMessagePayload;
      } else if (isFileEdited) {
        // Before other than "combinedMessage" or "text"
        // Edited message and removed image
        editMessagePayload.data = { ...editMessagePayload.data, message, combinedMessage: null, msgType: "text" };
        return editMessagePayload;
      } else if (isMessageEdited && editFile) {
        // Before other than "combinedMessage" or "text"
        // Edited message and same image
        editMessagePayload.data = { ...editMessagePayload.data, message, combinedMessage: [{ type: oldMessageType, content: oldMessage }], msgType: "combinedMessage" };
        return editMessagePayload;
      }
    } else if (oldMessageType === "combinedMessage" && isFileEdited && message.trim()) {
      // Only image removed, message unchanged
      editMessagePayload.data = { ...editMessagePayload.data, combinedMessage: null, msgType: "text" };
      return editMessagePayload;
    }
  };

  const sendMessage = async() => {
    console.log("[Debug] send message function called");
    if(uploadFileData){
      await uploadAttachmentToS3(uploadFileData)
    } else{
      if (editMessage && !isMessageEdited && !isFileEdited) {
        console.log('[Log] cancelling edit message');
        return;
      }
    console.log('chatmsg inside send msg 486',selectedChat,selectedSearchChat,selectedGroupChat,'attachmenturl condition',attachmentUrl && uploadFileData && (!message || message === ''),'atchment url',attachmentUrl)

    if (message.trim() !== '' || editMessage) {
      if (isChime) {
        // Handle Chime SDK messaging
        setSendingMessage(true);
        try {
        if (editMessage) {
          // Edit existing message via Chime
          const { id: existingMessageId, msgType: oldMessageType, message: oldMessage, combinedMessage: attachment } = editMessage;
          
          if (!existingMessageId) {
            console.error("[Debug] Cannot edit message - no message ID");
            return;
          }

          // Build updated content based on what changed
          let updatedContent: any = {
            ...editMessage,
            isMessageEdited: true,
          };

          if (message.trim() !== oldMessage) {
            if (oldMessageType === "combinedMessage") {
              if (isFileEdited) {
                // Edited message and removed image
                updatedContent = { ...updatedContent, message: message.trim(), combinedMessage: null, msgType: "text" };
              } else if (!message.trim()) {
                // Removed message with same image
                updatedContent = { ...updatedContent, message: attachment?.[0]?.content, combinedMessage: null, msgType: attachment?.[0]?.type };
              } else {
                // Edited message with the same image
                updatedContent = { ...updatedContent, message: message.trim(), msgType: "combinedMessage" };
              }
            } else if (oldMessageType === "text") {
              // Edited text message
              updatedContent = { ...updatedContent, message: message.trim(), msgType: "text" };
            } else if (isFileEdited) {
              // Before other than "combinedMessage" or "text" - Edited message and removed image
              updatedContent = { ...updatedContent, message: message.trim(), combinedMessage: null, msgType: "text" };
            } else if (isMessageEdited && editFile) {
              // Before other than "combinedMessage" or "text" - Edited message and same image
              updatedContent = { ...updatedContent, message: message.trim(), combinedMessage: [{ type: oldMessageType, content: oldMessage }], msgType: "combinedMessage" };
            }
          } else if (oldMessageType === "combinedMessage" && isFileEdited && message.trim()) {
            // Only image removed, message unchanged
            updatedContent = { ...updatedContent, combinedMessage: null, msgType: "text" };
          } else {
            // No changes
            console.log("[Debug] No changes detected, skipping edit");
            return;
          }

          console.log("[Debug] Updating Chime message with ID:", existingMessageId, updatedContent);
          await updateChimeMessage(existingMessageId, updatedContent);
          console.log("[Debug] Chime message updated successfully");

          // Update the local chimeMessages state to reflect the edit
          setChimeMessages(prev => prev.map(m => 
            m.id === existingMessageId ? { ...m, ...updatedContent } : m
          ));
        } else {
          // Send new message via Chime SDK
          // Don't include 'id' in content - Chime will assign the MessageId
          // The realtime echo will contain the correct Chime MessageId
          const chimeMessageContent = {
            toUserId: selectedChat?.to?.uId,
            toUserName: selectedChat?.to?.uFullName,
            userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
            userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
            userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
            chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
            replyId: replyToMessage ? replyToMessage?.id : null,
            replyData: replyToMessage ? {
              id: replyToMessage?.id,
              userId: replyToMessage?.userId,
              userName: replyToMessage?.userName,
              userAvatarUrl: replyToMessage?.userAvatarUrl,
              message: replyToMessage?.message,
              msgType: replyToMessage?.msgType,
              combinedMessage: replyToMessage?.combinedMessage,
              fileinfo: replyToMessage?.fileinfo,
              createdAt: replyToMessage?.createdAt
            } : null,
            message: message,
            combinedMessage: null,
            msgType: "text",
            createdAt: Date.now()
          };
          console.log("[Debug] Sending Chime message (no client id - Chime will assign MessageId)", chimeMessageContent);
          const chimeMessageId = await sendChimeMessage(chimeMessageContent);
          console.log("[Debug] Chime message sent, assigned MessageId:", chimeMessageId);
          updateLastMessage({
            variables: {
              chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
              lastMessageSendAt: dayjs().utc()
            }
          });
        }
        } finally {
          setSendingMessage(false);
        }

      } else {
      // Add your logic to send the message here
      const messageData = {
        type: "sendMessage",
        data: {
          toUserId: selectedChat?.to?.uId,
          toUserName: selectedChat?.to?.uFullName,
          userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
          userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName,
          userAvatarUrl: getUserAvatarUrl(profile?.getCurrentUser?.nodes?.[0]),
          chatRoomId: selectedChat?.chatroomId || selectedGroupChat?.chatroomId,
          replyId:replyToMessage ? replyToMessage?.id : null,
          message: message,
          combinedMessage: null,
          msgType: "text",
        },
      };

      console.log('message data 506', messageData)
      if (socketRef.current  && socketRef?.current?.readyState === 1) {
        if (editMessage) {
          const editPayload = getEditTextMessagePayload();
          console.log("[Log] Edit payload", editPayload);
          if (!editPayload) {
            return;
          }
          socketRef.current.send(JSON.stringify(editPayload));
        } else {
          socketRef.current.send(JSON.stringify(messageData));
          updateLastMessage({
            variables: {
              chatId: selectedChat?.chatId || selectedGroupChat?.chatId,
              lastMessageSendAt: dayjs().utc()
            }
          });
        }
      }
      }
      if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView(false);
      }
      setMessage(''); // Clear the input box after sending
      setAttachmentUrl('');
      setUploadFileData(null);
      handleCloseReply();
      setEditMessage(null);
      setEditFile(null);
      setIsMessageEdited(false);
      setIsFileEdited(false);
      // Ensure the textarea is focused after the message is sent and cleared
      setTimeout(() => {
        console.log('focus for settimeout---->')
         if (textareaRef.current) {        
        textareaRef.current.focus();
        textareaRef.current.style.height = 'auto'; // Reset height if necessary
         }
      }, 1000);  // Delay ensures the focus happens after DOM updates

      if(contentEditableRef.current){
        contentEditableRef.current.focus();
      }
    }
  }
  resetRecording();
  };

  // Adjust contentEditable div height dynamically based on content
  const adjustContentEditableHeight = () => {
    if (contentEditableRef.current) {
      contentEditableRef.current.style.height = 'auto'; // Reset height to auto
      contentEditableRef.current.style.height = `${contentEditableRef.current.scrollHeight}px`; // Set to scroll height
    }
  };

  // Adjust textarea height whenever the message state changes
  useEffect(() => {
    if(message !== ''){
    adjustContentEditableHeight();
    }
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
    if(contentEditableRef.current){
      contentEditableRef.current.focus();
    }
  }, [message]);

  useEffect(() => {
    if(chatMessages && selectedChat){
    const filteredData = chatMessages?.chatData?.filter(chat => !chat.isReadBy.some(reader => reader.userId === profile?.getCurrentUser?.nodes?.[0]?.uId)).map(chat => chat?.id);
    console.log('filtered data---->',filteredData);
    const unreadMessageData = {
      type: "updateUnreadMessages",
      data: {
        messageIds: filteredData || [],
        chatRoomId: selectedChat?.chatroomId,
        userId: profile?.getCurrentUser?.nodes?.[0]?.uId,
        userName: profile?.getCurrentUser?.nodes?.[0]?.uFullName
      }
    };
    
    // Check if messageIds has a length greater than 0 before sending
    if (unreadMessageData.data.messageIds.length > 0) {
      if (socketRef.current && socketRef.current.readyState === 1) {
        if (selectedChat !== undefined) {
          console.log('hitting unread api');
          socketRef.current.send(JSON.stringify(unreadMessageData));
        }
      }
    }
  
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }, 1000);
  }
  }, [chatMessages,profile,selectedChat]);
  

  useEffect(()=>{
    setMessage('');
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.style.height = 'auto';
    }
    setUploadFileData(null);
    setAttachmentUrl('');
    resetRecording();
    handleCloseReply();
    
    // Reset Chime states
    if (isChime) {
      setChimeMessages([]);
      setChimeNextToken(undefined);
    }
  },[selectedChat,selectedGroupChat,selectedSearchChat, isChime]);

  //Audio recordings actions
  const handleStartRecording = () => {
    setAudioRecording(true);
    shouldUploadRef.current = true;
    startRecording();
  };

  const handleStopRecording = () => {
    setAudioRecording(false);
    shouldUploadRef.current = true;
    setIsPause(false);
    stopRecording();
  };

   // Function to reset recording without triggering upload
   const resetRecording = () => {
    shouldUploadRef.current = false; 
    stopRecording();
    clearBlobUrl();
    setAudioRecording(false);
  };

  // const handlePauseRecording = () => {
  //   setIsPause(true);
  //   pauseRecording();
  // };

  // const handleResumeRecording = () => {
  //   setIsPause(false);
  //   resumeRecording();
  // };

  const handleCloseAttachment = () =>{
    setOpen(false);
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
      },1000);
  }
  
  const handlePlayAudio = (audio: HTMLAudioElement) => {
    // Pause the currently playing audio
    if (currentAudio && currentAudio !== audio) {
      currentAudio.pause();
    }

    // Update the state with the new audio
    setCurrentAudio(audio);
  };

  const handleConfirmation = (data:File) =>{
     setSelectedFile(data);
     setOpenConfirmationPopup(true);
  };

  // click yes button in confirmation popup
  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    setUploadFileData(selectedFile);
    setSelectedFile(null);
    if (editFile) {
      setEditFile(null);
      setIsFileEdited(true);
    }
  };

  // click no button in confirmation popup
  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
    setSelectedFile(null);
  };

  //To render the detailed view of attachment
  const handleClickCard = (data: singleChatType) =>{
       const msgType = data?.msgType === 'combinedMessage' ? data?.combinedMessage?.[0]?.type : data?.msgType;
       setViewUrl(data?.msgType === 'combinedMessage' ? data?.combinedMessage?.[0]?.content : data?.message);

       if(msgType === 'png') {
        setViewType('ImageViewer');
       }
       else if(msgType === 'mp4') {
        setViewType('VideoViewer');
       }
       else if (msgType === 'xls' || msgType === 'xlsx') {
        setViewType('ExcelViewer');
       }
       else if (msgType === 'docx' || msgType === 'doc') {
        setViewType('DocViewer');
       }
       else if (msgType === 'ppt' || msgType === 'pptx') {
        setViewType('PptViewer');
       }
       else if(msgType === 'pdf') {
        setViewType('PdfViewer');
       }
       else if (msgType === 'csv') {
        setViewType('CsvViewer');
       }
       else if(msgType === 'epub') {
        setViewType('epubViewer');
       }
       else {
        setViewType('');
        setViewUrl('');
      }
  };

  const handleCloseIcon = () => {
    if(loading || uploadLoading){
        return;
    }else {
      setUploadFileData(null); 
      if (editFile) {
        setEditFile(null);
        setIsFileEdited(true);
      }
      setAttachmentUrl('');
    }
  }

  const handleCloseReply = () =>{
    setReplyToMessage(null);
    setHighlightedMessageId(null);
  }

  useEffect(()=>{
    if(uploadFileData !== null || uploadFileData !== undefined){
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }
  },[uploadFileData]);

  useEffect(()=>{
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
  },[]);

  const getImage = (fileType: string) => {
    if (fileType === "application/pdf" || fileType === "pdf") {
      return pdfImg;
    }
    else if (fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || fileType === "application/vnd.ms-excel" || fileType === "xls" || fileType === "xlsx") {
      return excelPreview;
    }
    else if (fileType === "text/csv" || fileType === "csv") {
      return csvImg;
    }
    else if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || fileType === "application/msword" || fileType === "doc" || fileType === "docx") {
      return docsImg;
    } 
    else if (fileType === "application/vnd.ms-powerpoint" || fileType === "application/vnd.openxmlformats-officedocument.presentationml.presentation" || fileType === "ppt" || fileType === "pptx") {
      return powerpoint;
    } 
    else if (fileType === "application/epub+zip" || fileType === "epub") {
      return epub;
    }
    else {
      return undefined;
    }
  }

// Reusable components
const MediaPreview = ({ src, alt, className }: { src: string; alt: string; className: string }) => (
  <img src={src} alt={alt} className={className} />
);

const VideoPreview = ({ src, className }: { src: string; className: string }) => (
  <video src={src} className={className} autoPlay muted />
);

const AudioPreview = React.memo(({ src, className }: { src: string; className: string }) => {
  return (
    <audio
      src={src}
      className={className}
      controls
      controlsList="nodownload noplaybackrate noplay"
    />
  );
});

const FilePreview = ({ src, filename, fileType }: { src: string|undefined; filename: string; fileType: string }) => (
  <div className="replyFilePreview">
    <img src={src} alt={fileType} className="replyFileIcon" />
    <span className="replyFileName">{filename}</span>
  </div>
);

// Helper function to render content based on type
const renderContent = useMemo(() => {
  if (textareaRef.current) {
    textareaRef.current.focus();
  }
  if(replyToMessage){
  const mediaUrl = baseUrl + replyToMessage.message;

  switch (replyToMessage.msgType) {
    case "text":
      return <span className="replyContent">{replyToMessage.message}</span>;

    case "png":
      return (
        <div className="replymediaPreviewCtn">
          <MediaPreview src={mediaUrl} alt="replyImage" className="replyImagePreview" />
          <span className="replyMediaName">Sent an image</span>
        </div>
      );

    case "mp4":
      return (
        <div className="replymediaPreviewCtn">
          <VideoPreview src={mediaUrl} className="replyVideoPreview" />
          <span className="replyMediaName">Sent a video</span>
        </div>
      );

    case "mp3":
    case "3gp":
    case "webm":
    case "audio":
      return (
        <div className="replyAudioPreviewCtn">
          <span className="replyMediaName">Sent a voice message</span>
          <AudioPreview src={mediaUrl} className="replyAudioPreview" />
        </div>
      );

    case "pdf":
    case "csv":
    case "doc":
    case "docx":
    case "ppt":
    case "pptx":
    case "epub":
    case "xls":
    case "xlsx":
      return (
        <FilePreview
          src={getImage(replyToMessage.msgType)}
          filename={replyToMessage.fileinfo?.filename || "Unknown file"}
          fileType={replyToMessage.msgType}
        />
      );

    case "combinedMessage":
      return (
        <div className="replyCombinedMessageContainer">
          {replyToMessage.combinedMessage?.map((data, index) => {
            const combinedUrl = baseUrl + data?.content;
            switch (data.type) {
              case "png":
                return (
                  <div className="replymediaPreviewCtn" key={index}>
                    <MediaPreview src={combinedUrl} alt="replyImage" className="replyImagePreview" />
                    <span className="replyContent">{replyToMessage.message}</span>
                  </div>
                );

              case "mp4":
                return (
                  <div className="replymediaPreviewCtn" key={index}>
                    <VideoPreview src={combinedUrl} className="replyVideoPreview" />
                    <span className="replyContent">{replyToMessage.message}</span>
                  </div>
                );

              case "pdf":
              case "csv":
              case "doc":
              case "docx":
              case "ppt":
              case "pptx":
              case "epub":
              case "xls":
              case "xlsx":
                return (
                  <div key={index}>
                    <span className="replyContent">{replyToMessage.message}</span>
                    <FilePreview
                      src={getImage(data.type)}
                      filename={replyToMessage.fileinfo?.filename || "Unknown file"}
                      fileType={data.type}
                    />
                  </div>
                );

              default:
                return null;
            }
          })}
        </div>
      );

    default:
      return null;
  }
}
}, [replyToMessage]);


// Inside your component
const scrollToMessage = (messageId: string) => {
  console.log('inside scrollToMessage ',messageId)
  if (textareaRef.current) {
    textareaRef.current.focus();
  }
  const messageRef = messageRefs.current[messageId];
  console.log('inside scrollToMessage  message ref--->',messageRef,messageRefs.current[messageId])

  if (messageRef) {
    messageRef.scrollIntoView({ behavior: "smooth", block: "center" });
    // Highlight the message by setting the highlightedMessageId state
    setHighlightedMessageId(messageId);
    console.log('afterscroll hapen')
   // Clear the previous timeout if it exists
   if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }

  // Set a new timeout to remove highlight after 5 seconds
  timeoutRef.current = setTimeout(() => {
    setHighlightedMessageId(null);
  }, 5000);
  }
};

  const [showPicker, setShowPicker] = useState(false);


  const togglePicker = () => {
    setShowPicker(prevState => !prevState);
    resetRecording()
  };

  const addEmoji = (emoji:any) => {
    if (emoji.native !== editMessage?.message) {
      setIsMessageEdited(true);
    }
    setMessage((prevMessage) => prevMessage + emoji.native);  
  };

  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const resetEditMessage = () => {
    setEditMessage(null);
    setEditFile(null);
    setUploadFileData(null);
    setMessage("");
    setIsMessageEdited(false);
    setIsFileEdited(false);
  }

console.log('chatMessages',chatMessages,'chatmessage length',chatMessages?.totalCount);
console.log("[Debug] chimeMessages",chimeMessages,'chime message length',chimeMessages.length);

  return (
    <div className='commonChatBoxMainContainer'>
      <div className='commonChatBoxHeader'>
        {isMobileScreen && <img src={exitIcon} alt='backIcon' className='backIcon' onClick={()=>setIsSidebarOpen(true)} />}
        <div>
        <span className='ChatTitle'>{selectedChat ? selectedChat?.to?.uFullName : selectedGroupChat ? selectedGroupChat?.chatroomName : "-"}</span>
        <div className='chatStatusCtn'>
          {
            ((selectedChat && (selectedChat?.chatType !== 'SCHOOL' && selectedChat?.chatType !== 'TEACHERS')) && selectedChat?.to?.uChatActive) ?
              <img src={UserActiveIcon} alt={`active`} className='userActiveStyle' />
              : <></>
          }
          <span className='ChatStatus'>{((selectedChat && (selectedChat?.chatType !== 'SCHOOL' && selectedChat?.chatType !== 'TEACHERS')) && selectedChat?.to?.uChatActive) ? "Active Now" : ""}</span>
        </div>
        </div>
      </div>
      {(() => {
        const baseSource: any[] = isChime ? chimeMessages : (chatMessages?.chatData || []);
        const filteredSource = baseSource
          .filter(Boolean)
          .filter((m) => m?.id && (m?.msgType || m?.message || (m?.combinedMessage && m?.combinedMessage.length)));
        const dataLength = filteredSource.length;
        return (
      <div className={(dataLength > 0) ? 'commonChatBoxBody' : 'noDataFoundCtn'}>
        {(!isChime ? chatLoading : (chimeClientLoading || chimeMessagesLoading)) ?
          <div className='infinite-scroll-loader'><CircularProgress /></div>
          :
          (dataLength > 0) ?
          <InfiniteScroll
            dataLength={dataLength}
            next={isChime ? loadChimeMessages : loadMore}
            hasMore={isChime ? !!chimeNextToken : hasMore}
            loader={<div className='infinite-scroll-loader'><CircularProgress /></div>}
            inverse={true}
            height={'100%'}
            style={{
              height:'64vh',
              display: 'flex',
              flexDirection: 'column-reverse',
              gap: '5px',
              paddingRight: '3px'
            }}
            className='infinite-scroll-container'
          >
            {<div ref={messagesEndRef} />}
              {
                filteredSource.map?.((data: any, index) => {
                  const dataSource: any[] = filteredSource;
                  const currentUserId = data?.userId;

                  // Step 1: Get continuous messages from the same user (in reverse layout, this is from 'index' upwards)
                  const continuousMessages = [];
                  for (let i = index; i >= 0; i--) {  // Reverse iteration because of column-reverse layout
                    if (dataSource[i]?.userId !== currentUserId) {
                      break;
                    }
                    continuousMessages.push(dataSource[i]);
                  }

                  // Step 2: Filter out deleted messages from continuousMessages array
                  const validMessages = continuousMessages.filter((message: singleChatType) => {
                    return !((message?.deletedForEveryOne && message?.deletedForEveryOne !== null) ||
                      (message?.deletedForMe && message?.deletedForMe !== null && message?.userId === profile?.getCurrentUser?.nodes?.[0]?.uId));
                  });

                  // Step 3: Check if the current message is the last message in the validMessages array
                  const isLastMessage = validMessages.length > 0 && data?.id === validMessages[validMessages.length - 1]?.id;
                  
                  console.log("[Debug] dataSource", dataSource);
                  console.log("[Debug] continuousMessages", continuousMessages);
                  console.log("[Debug] validMessages", validMessages);
                  console.log("[Debug] isLastMessage for message ID", data?.id, ":", isLastMessage);
                  console.log("[Debug] dataSource[index+1] previousdata", dataSource[index + 1]);
                  console.log("*********************************************************************");
                  return (
                    <div
                    key={data?.id || `${index}`}
                    ref={el => (messageRefs.current[data?.id || `${index}`] = el)} 
                  >
                    <ChatCard
                      key={data?.id || `${index}`}
                      data={data}
                      isLastMessage={isLastMessage}
                      highlighted={highlightedMessageId ? (data?.id === highlightedMessageId) : false}
                      type={type}
                      onClickCard={() => handleClickCard(data)}
                      onPlayAudio={handlePlayAudio}
                      previousData={dataSource[index + 1]}
                      getImage={getImage}
                      socketRef={socketRef}
                      setReplyToMessage={setReplyToMessage}
                      replyToMessage={replyToMessage}
                      scrollToMessage={scrollToMessage}
                      handleEditMessage={handleEditMessage}
                      handleDeleteMessage={isChime ? handleDeleteChimeMessage : undefined}
                      isChime={isChime}
                    />
                    </div>
                  );
                })
              }
          </InfiniteScroll>
          :
          <div className='NodataFound'>The chat room is now set up and ready for you to start a conversation.</div>
        }
      </div>
      )
      })()}
      <div className='commonChatBoxFooter'>
        <div className='clickable-action-ctn'>
          {audioRecording ? (
            <Tooltip
              title={"Recording..."}
              open={audioRecording}
              disableHoverListener
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: '10px',
                    backgroundColor: '#222222ad',
                    color: '#fff',
                    borderRadius: '4px',
                    fontSize: '14px',
                    lineHeight: '1.5',
                  }
                },
                arrow: {
                  sx: {
                    color: '#222222ad',
                  }
                },
              }}
            >
              <div className='chatMicBox' onClick={handleStopRecording}>
                <img src={StopIcon} style={{ width: '15px', height: '15px' }} alt="Stop Recording" />
              </div>
            </Tooltip>
          ) : (
            <div className='chatMicBox' onClick={handleStartRecording} >
              <img src={voiceChatIcon} alt="Start Recording" />
            </div>
          )}
          <div className='chatAttachmentBox' onClick={() => {setOpen(true); resetRecording();}}><img src={AttachmentIcon} alt='attachment' /></div>
          <div onClick={togglePicker} className='chatAttachmentBox'><img src={emoji2} alt='attachment'className='chatEmoji' /></div>
          {showPicker && (
        <div
        ref={pickerRef}
          style={{        
            position: 'absolute',
            bottom: '50px',
            left: '0',
            zIndex: 1000,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px'
          }}
        >
          <div className="picker">
                <Suspense fallback={<CircularProgress size={24} />}>
                  <Picker
                    emojiSize={23}
                    emojiButtonSize={30}
                    onEmojiSelect={addEmoji}
                    theme ={'light'}
                    skinTonePosition={'search'}
                    previewPosition ={'none'}
                    set ={'google'}
                    maxFrequentRows = {2}
                    
                  />
                </Suspense>
              </div>
        </div>
      )}
          <div className='outerMessagesCtn'>
            <div className='messageCtn' style={{ background: editMessage ? 'rgba(240, 243, 245, 0.3)' : undefined }}>
              {editMessage && (
                <div className="editing-message">
                  <p>Editing message</p>
                  <img src={closeIcon} onClick={resetEditMessage} alt="Close Icon" />
                </div>
              )}
              <div className='chatInputContainer'>
              {replyToMessage && (
                  <div className="replyContainer"  onClick={() =>  
                    {if (replyToMessage?.id) {
                    setTimeout(() => {
                      scrollToMessage(replyToMessage?.id);
                    }, 100);
                  }}}>
                    <div className="replyDetails">
                      <span className="replySender">{replyToMessage.userName}</span>
                      <span className="replyContentWrapper">{renderContent}</span>
                    </div>
                    <img
                      className="replyCloseIcon"
                      src={whiteClose}
                      alt="closeIcon"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleCloseReply();
                      }}
                    />
                  </div>
                )}
                {
                 (audioRecording) ? 
                    <span className='recordingPlaceholder'>
                      <div className="waveform-bars">
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                      </div>
                    </span> :
                 <textarea
                  ref={textareaRef}
                  className='chatInput'
                  placeholder='Type here...'
                  value={message}
                  disabled={(loading || uploadLoading || sendingMessage)}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  autoFocus={true}
                />
                }{
                  audioRecording ? 
                  <button className={(loading || uploadLoading || sendingMessage) ? 'sendDisableBtn' : 'recordCancelBtn'} onClick={resetRecording} disabled={loading || uploadLoading || sendingMessage}>
                  {(loading || uploadLoading || sendingMessage) ? <CircularProgress size={24} /> : <img src={whiteClose} alt='close' />}
                </button> 
                :
                <button className={(loading || uploadLoading || sendingMessage) ? 'sendDisableBtn' : 'sendButton'} onClick={sendMessage} disabled={loading || uploadLoading || sendingMessage}>
                  {(loading || uploadLoading || sendingMessage) ? <CircularProgress size={24} /> : <img src={(loading || uploadLoading || sendingMessage) ? SendDisableIcon : sendIcon} alt='send' />}
                </button>
                }
                {((editFile && editMessage) || uploadFileData) && (
                  <div className={((editFile && editMessage && ['mp4', 'webm', 'mov', 'mkv'].includes(editFile.fileType)) || uploadFileData?.type === 'video/mp4')?'attachmentVideoCtn':'attachmentCtn'}>
                    <img
                      className='attchmentCloseIcon' 
                      src={whiteClose}
                      onClick={handleCloseIcon}
                      alt='closeIcon'
                    />
                    {(editFile && editMessage) &&
                      (['mp4', 'webm', 'mov', 'mkv'].includes(editFile.fileType) ? (
                        <video
                          src={`${baseUrl}${editFile.s3Path}`}
                          className="attachmentImage"
                          autoPlay
                          muted
                        />
                      ) : (
                        <img
                          src={!getImage(editFile.fileType) ? `${baseUrl}${editFile.s3Path}` : getImage(editFile.fileType)}
                          alt="attachmentImage"
                          className="attachmentImage"
                        />
                      ))}
                    {((!editFile && uploadFileData) && ((uploadFileData?.type === "video/mp4") ? (
                      <video
                        src={URL.createObjectURL(uploadFileData)}
                        className="attachmentImage"
                        autoPlay
                        muted
                      />
                      ) : (
                      <img
                        src={ getImage(uploadFileData?.type) === undefined ? URL.createObjectURL(uploadFileData) : getImage(uploadFileData?.type) }
                        alt="attachmentImage"
                        className="attachmentImage"
                      /> 
                    )))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={typingUsers?.length > 0 ?"typingMessage":"EmptyTypingMessage"}>
          {(
                (() => {
                  const filteredTypingUsers = typingUsers.filter((user) => {
                    const userRoomId = isChime ? user.channelArn : user.chatRoomId;
                    const chatRoomId = isChime ? selectedChat?.chimeChannelArn : selectedChat?.chatroomId;
                    const groupRoomId = isChime ? selectedGroupChat?.chimeChannelArn : selectedGroupChat?.chatroomId;

                    return userRoomId === chatRoomId || userRoomId === groupRoomId;
                  });


                  if (filteredTypingUsers.length === 1) {
                    return `${filteredTypingUsers[0]?.fromUserName} is typing...`;
                  } else if (filteredTypingUsers.length === 2) {
                    return `${filteredTypingUsers[0]?.fromUserName} and ${filteredTypingUsers[1]?.fromUserName} are typing...`;
                  } else if (filteredTypingUsers.length > 2) {
                    return "Many people are typing...";
                  }
                })()
              )}
        </div>
      </div>
      <ChatAttachmentPopup
        open={open}
        handleClose={handleCloseAttachment}
        setUploadFileData = {setUploadFileData}
        uploadFileData = {uploadFileData}
        editFile={editFile}
        handleConfirmation = {handleConfirmation}
        setUploadLoading = {setUploadLoading}
        uploadLoading = {uploadLoading}
      />
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={`Are you sure you want to Replace the file?`}
        gifData={DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'221px'}
      />
    </div>
  )
}

export default CommonChatBox;
